// Routes where client-side analytics (GA4, Yandex Metrika, Meta Pixel,
// web-vitals RUM) must NOT load. Three reasons:
//
// 1. /admin/* — operator pages. Pollutes traffic/page reports with own
//    activity (52 admin/bookings views in May digest were ours, not real
//    users) and burns ~280 KB of analytics scripts on a tab kept open
//    all day.
// 2. /comingsoon — placeholder, no real audience signal.
// 3. /booking/<token> — guest booking pages with UUID tokens in URL.
//    Forwarding token-bearing path to GA4 / Meta would leak a
//    capability-grade identifier into third-party properties (PII risk).
//
// Locale prefixes (/ru, /ka) are mirrored — admin/comingsoon/booking
// pages exist under each locale via @nuxtjs/i18n's prefix_except_default.
const SUPPRESSED_RE = /^\/(?:ru\/|ka\/)?(?:admin|comingsoon|booking)(?:\/|$)/;

export function isAnalyticsSuppressed(pathname: string): boolean {
  return SUPPRESSED_RE.test(pathname);
}
